module.exports = __webpack_public_path__ + "img/steps-data.62c06d98.png";